import React from 'react';
import Header from '../components/Header.js';
import '../style.css';
import Products from './Products.js';
import Clientele from './Clientele.js';
import Contact from './Contact.js';
import About from './About.js';
import Careers from './Careers.js';
import SEO from '../components/SEO.js';

const Home = () => {
  return (
    <>
      <SEO
        title="D Base Solutions | Enterprise Software, EdTech & University ERP"
        description="Official website of D Base Solutions Pvt Ltd (DBS) - Premier enterprise software and EdTech company delivering EdVedha LMS, UNIcode University Exam Suite, iCampus BOAT ERP, and exam automation across India."
        keywords="D Base Solutions, D Base Solutions Pvt Ltd, DBS, EdVedha, UNIcode, iCampus BEAT, iCampus BOAT, ERP software, university exam management, education software India, Eluru, Vijayawada"
        canonical="https://dbasesolutions.in/"
        ogImage="/og-image.png"
      />
      <Header />
      <About />
      <Products />
      <Clientele />
      <Careers />
      <Contact />
    </>
  );
};

export default Home;
